<template>
  <v-container class="subscribe-container">
    <v-row>
      <v-col xs="12" align="left" light>
        <p class="title">Subscribe (Upgrade)</p>
        <v-card v-if="!showPayment" class="mx-auto" max-width="400" outlined>
          <v-card-title class="headline">PRO Membership</v-card-title>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-subtitle>
                Get access to PRO level Saga Dashboard Features
              </v-card-subtitle>
            </div>
            <div class="ma-3 price-container text-center">
              <p class="price-pro headline font-weight-medium">2.95</p>
              <p class="price-freq caption font-weight-thin text-center">
                Per Month<br />Billed monthly
              </p>
            </div>
          </div>
          <div class="text-center button-container">
            <!-- <v-btn
              id="submit-basic"
              :loading="loading"
              @click="goToPaymentPage('pro')"
            >
              Continue
            </v-btn> -->
            <v-btn outlined color="blue" large @click="checkout('EUR')">
              Use Euro
            </v-btn>
            <v-btn outlined color="blue" large @click="checkout('USD')">
              Use USD
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Upgrade',
  data() {
    return {
      stripeAPIToken: 'pk_test_Ex4ZqT4BRnOyJimuVax044sk00iVC52QuR',
      stripe: '',
      loading: false,
      showPayment: false
    }
  },
  mounted() {
    this.includeStripe(
      'js.stripe.com/v3/',
      // eslint-disable-next-line func-names
      function() {
        this.configureStripe()
      }.bind(this)
    )
  },
  methods: {
    includeStripe(URL, callback) {
      const documentTag = document
      const tag = 'script'
      const object = documentTag.createElement(tag)
      const scriptTag = documentTag.getElementsByTagName(tag)[0]
      object.src = `https://${URL}`
      if (callback) {
        object.addEventListener(
          'load',
          // eslint-disable-next-line func-names
          function(e) {
            callback(null, e)
          },
          false
        )
      }
      scriptTag.parentNode.insertBefore(object, scriptTag)
    },
    configureStripe() {
      // eslint-disable-next-line no-undef
      this.stripe = Stripe(this.stripeAPIToken)
    },
    checkout(currency) {
      let plan
      if (currency === 'USD') {
        plan = 'plan_HF3w40AMd770bD'
      } else {
        plan = 'plan_HEx1kv9zteQEJG'
      }
      this.stripe
        .redirectToCheckout({
          clientReferenceId: this.$store.state.authentication.user.id,
          customerEmail: this.$store.state.authentication.user.email,
          items: [
            {
              plan,
              quantity: 1
            }
          ],
          successUrl: 'http://localhost:8080/account',
          cancelUrl: 'http://localhost:8080/cancel'
        })
        // eslint-disable-next-line func-names
        .then(function(result) {
          if (result.error) {
            // If `redirectToCheckout` fails due to a browser or network
            // error, display the localized error message to your customer.
            const displayError = document.getElementById('error-message')
            displayError.textContent = result.error.message
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.subscribe-container {
  background-color: white;
  border-radius: 10px;
  margin-top: 20px;
  margin-bottom: 20px;

  .price-container {
    width: 40%;
    .price-pro {
      color: #455a64;
      display: block;
    }
    .price-freq {
      display: block;
      margin-top: -10px;
    }
  }
  .button-container {
    padding-bottom: 14px;
  }
  .payment-form {
    .total-due-now {
      color: red;
    }
  }
}
</style>
